import axios  from "axios"

export default {
  namespaced: true,
  state: {
    regionData: [],
    regionLoading: false,
  },
  mutations: {
    setRegionData(state, data) {
      state.regionData = data
    },
    setRegionLoading(state, data) {
      state.regionLoading = data
    }
  },
  actions: {
    async queryOssRegionDataAction({ commit, state }) {

      if(!state.regionLoading){
        commit("setRegionLoading", true)
        try {
          const {data} = await axios.get('https://library.liangbaba.com/jsons/areadata.json', {
            withCredentials: false
          })
          commit("setRegionLoading", false)
          if (data && data.length) {
            commit("setRegionData", data)
          }
        } catch (error) {
          console.log(error);
          commit("setRegionLoading", false)
        }
      }
    }
  }
}